<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
      action="j_spring_security_check"
    >
      <div class="title-container">
        <h3 class="title">后台登录</h3>
      </div>

      <el-form-item prop="username">
        <span class="svg-container"></span>
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="账号"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="on"
        />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
        <el-form-item prop="password">
          <span class="svg-container"></span>
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="密码"
            name="password"
            tabindex="2"
            autocomplete="on"
            @blur="capsTooltip = false"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd"></span>
        </el-form-item>
      </el-tooltip>

      <el-button
        :loading="loading"
        type="primary"
        style="width:100%;margin-bottom:30px;"
        @click.native.prevent="handleLogin"
      >登录</el-button>
    </el-form>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader.vue";
import { mapActions, mapState } from "vuex";
import axios from "axios";
import { type } from "os";

export default {
  name: "login",
  components: {},
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [{ required: true, trigger: "blur", message: "请输入账号" }],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }]
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {}
    };
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    }
  },
  mounted() {
    window.wx_login = this.wx_login;
    window.wx_login_ok = this.wx_login_ok;
  },
  computed: {
    ...mapState(["toUser"]),
    valid() {
      if (this.loginname.length === 0) {
        return { r: false, msg: "请输入账号" };
      }
      if (this.pass.length < 6) {
        return { r: false, msg: "密码格式不正确" };
      }
      return { r: true, msg: "" };
    }
  },
  methods: {
    ...mapActions(["setData"]),
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          axios
            .get("/login!ajaxLogin.action", {
              params: {
                loginname: this.loginForm.username,
                password: this.loginForm.password
              }
            })
            .then(response => {
              this.loading = false;
              if (response.data.state === 0) {
                let parms = {};
                parms.toUser = response.data.toUser;
                parms.wwzqx = response.data.wwzqx;
                parms.modules = response.data.modules;
                parms.wwzmod = response.data.wwzmod;
                parms.footlist = response.data.footlist;
                parms.custname = response.data.custname;
                parms.userfunc = response.data.userfunc;
                parms.loginname = this.loginForm.username;
                this.setData(parms);
                this.$router.push({
                  name: "index",
                  params: {}
                });
              } else if (response.data.state === 1) {
                this.$alert("登录失败，账号或密码错误!", "登录提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              } else if (response.data.state === 2) {
                 this.$alert("账号即将过期，请尽快修改密码!", "登录提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
                let parms = {};
                parms.toUser = response.data.toUser;
                parms.wwzqx = response.data.wwzqx;
                parms.modules = response.data.modules;
                parms.wwzmod = response.data.wwzmod;
                parms.footlist = response.data.footlist;
                parms.custname = response.data.custname;
                parms.userfunc = response.data.userfunc;
                parms.loginname = this.loginForm.username;
                this.setData(parms);
                this.$router.push({
                  name: "index",
                  params: {}
                });
              } else {
                this.$alert("账号过期或其他异常，请联系管理员!", "登录提示", {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            })
            .catch(function(error) {
              window.console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 220px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
</style>

